module.exports = __webpack_public_path__ + "img/logo.ddb41754.webp";